import { ActionFiterType } from '@/components/ActionsTable/ActionFilters/Template/types';

export const extractActionName = (
  actionTypeId: number,
  actionTypes: ActionFiterType[] | undefined,
) => {
  if (!actionTypes?.length) {
    return actionTypeId.toString();
  }

  const actionType = actionTypes.find((at) => at.id === actionTypeId);
  if (actionType) {
    return actionType.name.toString();
  }

  return actionTypeId.toString();
};
